import { withAsyncScript } from '../../../AsyncScriptWrapper/AsyncScriptWrapper.react';

import SearchHeader from './container';

export default withAsyncScript(SearchHeader, {
  id: 'gmaps',
  global: 'google',
  propName: 'googleAPI',
});



// WEBPACK FOOTER //
// ./app/src/components/Discovery/components/SearchHeader/index.jsx